var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 17.375H24.875C25.0408 17.375 25.1997 17.4408 25.3169 17.5581C25.4342 17.6753 25.5 17.8342 25.5 18C25.5 18.1658 25.4342 18.3247 25.3169 18.4419C25.1997 18.5592 25.0408 18.625 24.875 18.625H12.375C12.2092 18.625 12.0503 18.5592 11.9331 18.4419C11.8158 18.3247 11.75 18.1658 11.75 18C11.75 17.8342 11.8158 17.6753 11.9331 17.5581C12.0503 17.4408 12.2092 17.375 12.375 17.375Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6336 18L17.8174 23.1825C17.9348 23.2999 18.0007 23.459 18.0007 23.625C18.0007 23.791 17.9348 23.9501 17.8174 24.0675C17.7 24.1849 17.5409 24.2508 17.3749 24.2508C17.2089 24.2508 17.0498 24.1849 16.9324 24.0675L11.3074 18.4425C11.2492 18.3844 11.203 18.3155 11.1715 18.2395C11.14 18.1636 11.1238 18.0822 11.1238 18C11.1238 17.9178 11.14 17.8364 11.1715 17.7605C11.203 17.6845 11.2492 17.6156 11.3074 17.5575L16.9324 11.9325C17.0498 11.8151 17.2089 11.7492 17.3749 11.7492C17.5409 11.7492 17.7 11.8151 17.8174 11.9325C17.9348 12.0499 18.0007 12.209 18.0007 12.375C18.0007 12.541 17.9348 12.7001 17.8174 12.8175L12.6336 18Z",
    fill: "#161616"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.79e657ebbf99e966c48766c8f98bb320.svg";
export { ForwardRef as ReactComponent };